import React from 'react';
import styles from './InitiativeCardHeader.module.scss';
import { SFText } from 'sfui';
import { TagsInformation } from './TagsInformation/TagsInformation';
import { InitiativeTags } from '../../../../../../../Models/InitiativeValue';
import { InitiativeCardActions } from './InitiativeCardActions/InitiativeCardActions';

export interface InitiativeCardHeaderProps {
  className?: string;
  name: string;
  tags: InitiativeTags;
  isButtonDisabled: boolean;
  onSeeRecentReports: () => void;
}

export const InitiativeCardHeader = ({
  className = '',
  name,
  tags,
  isButtonDisabled,
  onSeeRecentReports
}: InitiativeCardHeaderProps): React.ReactElement<InitiativeCardHeaderProps> => {
  return (
    <div className={`${styles.initiativeCardHeader} ${className}`}>
      <div className={styles.information}>
        <div>
          <SFText type="component-messages" sfColor="neutral">
            INITIATIVE
          </SFText>
          <SFText type="component-title">{name}</SFText>
        </div>

        <InitiativeCardActions
          isButtonDisabled={isButtonDisabled}
          onSeeRecentReports={onSeeRecentReports}
        />
      </div>
      <div className={styles.valueAndChips}>
        <SFText type="component-messages" sfColor="neutral">
          TAGS
        </SFText>
        <div className={styles.chips}>
          <TagsInformation tags={tags} />
        </div>
      </div>
    </div>
  );
};
